<template>
    <div>
        <p v-if="loading">Loading...</p>
        <div v-else>
            <file-manager-component
                v-on:fm::asset::select="selectAsset"
                v-on:fm::asset::dblclick="addAsset"
                :createData="createAsset"
                :updateBatch="updateAssets"
                :allowedExtensions="schema.file.extensions"
                :content="assets">
                </file-manager-component>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import Vuex from 'vuex';
import FileManagerComponent from '../AssetManagerComponent';

export default {
    data() {
        return {
            asset: null,
            loading: false,
        }
    },

    components: {
        FileManagerComponent,
    },

    props: ['value', 'schema', 'type'],

    watch: {

    },

    mounted() {

    },

    computed: {
        ...Vuex.mapGetters({
            assets: 'assets',
        }),
    },

    methods: {
        ...Vuex.mapActions([
            'getAssets', 'createAsset', 'updateAssets',
        ]),

        selectAsset(asset) {
            this.asset = asset;
            this.$emit('input', {
                file: asset.id,
                comment: '',
            });
        },

        addAsset(asset) {
            this.$emit('add', {
                file: asset.id,
                comment: '',
            });
        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/table-elements/FileFormComponent.vue